<template>
    <button v-if="hasAccess" type="button" class="my-home-button" @click="$router.push('/my-home')">
        <svg class="my-home-button__corners" viewBox="0 0 323 28" preserveAspectRatio="none" aria-hidden="true">
            <path d="M8 1H1V8 M315 1H322V8 M1 20V27H8 M322 20V27H315" />
        </svg>
        {{ $t('mainPage.myHomeButton') }}
    </button>
</template>

<script>
import { ref, watch } from 'vue'
import ApiManager from '@/services/ApiManager'
import { getAccountByLogin } from '@/db/accountService'
import { calculateFingerprint } from '@/services/fingerprint'
import { decryptMessage } from '@/services/cryptoUtils'

export default {
    name: 'MyHomeButton',
    props: {
        login: { type: [String, Number], default: null }
    },
    setup(props) {
        const hasAccess = ref(false)
        watch(() => props.login, async (login, previousLogin, onCleanup) => {
            hasAccess.value = false
            let active = true
            const controller = new AbortController()
            onCleanup(() => {
                active = false
                controller.abort()
            })
            if (!login) return
            try {
                const account = await getAccountByLogin(login)
                if (!account || !active) return
                const fingerprint = await calculateFingerprint()
                const authToken = await decryptMessage(account.token, fingerprint, account.iv)
                if (!active) return
                const result = await ApiManager.getMyHomeAccess(authToken, controller.signal)
                if (active) hasAccess.value = result.data?.has_access === true
            } catch (error) {
                // An optional eligibility check must never block the home page.
                if (active) hasAccess.value = false
            }
        }, { immediate: true, flush: 'sync' })
        return { hasAccess }
    }
}
</script>

<style scoped>
.my-home-button {
    position: relative;
    display: block;
    width: 90%;
    height: 28px;
    margin: 22px auto 6px;
    padding: 0;
    border: 0;
    background: transparent;
    color: #e0c522;
    font-family: inherit;
    font-size: 13px;
    line-height: 14px;
    text-align: center;
}
.my-home-button::before {
    content: '';
    position: absolute;
    inset: 3px 3px;
    background: rgba(224, 197, 34, 0.1);
    pointer-events: none;
}
.my-home-button__corners {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    fill: none;
    stroke: #e0c522;
    stroke-width: 1;
    pointer-events: none;
}
</style>
